<template>
  <a-popover
    v-model="visible"
    trigger="click"
    placement="bottomRight"
    overlayClassName="header-notice-wrapper"
    :getPopupContainer="() => $refs.noticeRef.parentElement"
    :autoAdjustOverflow="true"
    :arrowPointAtCenter="true"
    :overlayStyle="{ width: '100%', maxWidth: '400px', top: '50px' }"
  >
    <template slot="content">
      <a-spin :spinning="loading">
        <a-tabs v-if="Object.keys(this.notificationGroup).length !== 0" :tabBarGutter="0" >
          <a-tab-pane
            v-for="(s, key) in notificationGroup"
            :tab="`${s.label}(${s.result.length  > 99 ? '99+' : s.result.length})`"
            :key="key"
          >
            <a-list>
              <template v-if="s.result.length">
                <a-list-item
                  v-for="(item, index) in s.renderNotification"
                  :key="index"
                  style="padding: 5px 0;"
                >
                  <tk-flex
                    between
                    middle
                    style="width: 100%;cursor: pointer;"
                    @click.native="toNewPage(item, index, key)"
                  >
                    <tk-flex style="width:240px" column>
                      <tk-flex style="font-size:14px; font-weight:700;">
                        <div v-if="!item.readUsers.includes(user.objectId)">
                          <span :style="style"></span>
                        </div>
                        <div>
                          <span style="color: '#C5C8CE;word-break: break-all;">{{item.head}}</span>
                        </div>
                      </tk-flex>
                      <div class="m-l-16 m-t-4" style="color:#C5C8CE ">{{ myDate(item.createdAt)}}</div>
                    </tk-flex>
                    <tk-flex gutter="8">
                      <a-button size="small" @click.stop="markRead(item, index, key)">已读</a-button>
                    </tk-flex>
                  </tk-flex>
                </a-list-item>
              </template>
              <tk-flex column center v-else>
                <tk-image :src="bell"></tk-image>
                <div class="m-t-20">暂无消息通知~</div>
              </tk-flex>
              <a-list-item>
                <a-pagination
                  @change="change(key, 3, $event)"
                  simple
                  :pageSize="3"
                  :current="s.currentPage"
                  :total="s.result.length "
                />
              </a-list-item>
            </a-list>
          </a-tab-pane>
        </a-tabs>
        <tk-flex column center v-else>
          <tk-image :src="bell"></tk-image>
          <div class="m-t-20">暂无消息通知~</div>
        </tk-flex>
      </a-spin>
    </template>
    <span @click="fetchNotice" class="header-notice" ref="noticeRef">
      <a-badge :count="messageCount">
        <a-icon style="font-size: 16px; padding: 4px" type="bell" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script>
import gql from 'graphql-tag'
import bell from '../../assets/images/bell.png'
import { mapState } from 'vuex'
const permission = require('../../core/permissions.yaml')
export default {
  data () {
    return {
      bell,
      process,
      page0: 1,
      page1: 1,
      page2: 1,
      page3: 1,
      page4: 1,
      page5: 1,
      page6: 1,
      lang: localStorage.lang,
      loading: false,
      visible: false,
      // 消息通知总数据
      notification: [],
      // 分组消息通知数据
      notificationGroup: {},
      renderNotification: [],
      style: { // 红点
        'width': '7px',
        'height': '7px',
        'border-radius': '50%',
        'display': 'inline-block',
        'margin-right': '5px',
        'margin-left': '5px',
        'background-color': '#FD4B80',
        'margin-bottom': '3px'
      },
      styleEmpty: {
        'width': '7px',
        'height': '7px',
        'border-radius': '50%',
        'display': 'inline-block',
        'margin-right': '5px',
        'margin-left': '5px',
        'margin-bottom': '3px'
      },
      messageCount: 0
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasNew () {
      return !!this.notification.length
    }
  },
  destroyed () {
    console.log(this.$apollo.subscriptions)
    if (this.$apollo.subscriptions.platformNotice) {
      this.$apollo.subscriptions.platformNotice.skip = true
    }
  },
  mounted () {
    this.noticeSubscription()
  },
  methods: {
    // 按指定类型分组
    arrGroup (arr, fn) {
      /// 根据权限获取分类
      const obj = {}
      console.log('测试', this.$store.state.user)
      // let permissionList = this.$store.state.user.adminRole ? permission : this.$store.state.auth
      // let permissionF = permissionList.map(s => s.children.map(e => e.key))
      let permissionF = []
      if (this.$store.state.user.level === '3') {
        permissionF = ['store', 'stock', 'order', 'activity', 'gift']
      }
      if (this.$store.state.user.level === '2') {
        permissionF = ['store']
      }
      if (this.$store.state.user.adminRole === 'superAdmin' || (this.$store.state.user.adminRole === 'admin' && this.can('reviewGiftApplyModel'))) {
        permissionF = ['gift']
      }

      let defaultList = ['store', 'stock', 'order', 'gift', 'activity']
      permissionF.forEach(key => {
        if (defaultList.includes(key)) {
          switch (key) {
            case 'store':
              obj[key] = {
                currentPage: this.page0,
                result: [],
                renderNotification: [],
                label: '门店审核'
              }
              break
            case 'stock':
              obj[key] = {
                currentPage: this.page1,
                result: [],
                renderNotification: [],
                label: '铺货库存'
              }
              break
            case 'order':
              obj['order'] = {
                currentPage: this.page2,
                result: [],
                renderNotification: [],
                label: '确认订单'
              }
              break
            case 'gift':
              obj['gift'] = {
                currentPage: this.page3,
                result: [],
                renderNotification: [],
                label: '区域赠品'
              }
              break
            case 'activity':
              obj[key] = {
                currentPage: this.page4,
                result: [],
                renderNotification: [],
                label: '活动'
              }
              break
            default:
              obj[key].label = '-'
              break
          }
        }
      })
      arr.forEach(item => {
        const key = JSON.parse(JSON.stringify(fn(item)))
        obj[key] = obj[key] || {}
        obj[key].result.push(item)
      })
      return obj
    },
    // 新通知监听
    noticeSubscription () {
      let permissionS = []
      let permissionList = this.$store.state.user.adminRole ? permission : this.$store.state.auth
      permissionList.forEach(element => {
        if (element.children) {
          permissionS = permissionS.concat(element.children.map(s => s.value))
        }
      })
      this.$apollo.addSmartSubscription('platformNotice', {
        query: gql`subscription MySubscription($user: bpchar!, $readUser: String!, $permissionF: [String!], $permissionS: [String!]) {
          platformNotice(
            where: {
              _or: [
                {
                  agent: {_eq: $user}
                },
                {
                  permissionF: {_in: $permissionF},
                  permissionS: {_in: $permissionS}
                }
              ],
              _not: {
                readUsers: {
                  _has_key: $readUser
                }
              }
            },
            order_by: {
              createdAt: desc
            },
            limit: 1000
          ) {
            agent
            associationType
            className
            createdAt
            head
            objectId
            permissionF
            permissionS
            resourceId
            readUsers
            type
            updatedAt
          }
        }`,
        variables () {
          // let permissionS = []
          // let permissionList = this.$store.state.user.adminRole ? permission : this.$store.state.auth
          // let permissionF = permissionList.map(s => s.value)
          // permissionList.forEach(element => {
          //   if (element.children) {
          //     permissionS = permissionS.concat(element.children.map(s => s.value))
          //   }
          // })
          let permissionF = []
          let permissionS = []
          if (this.$store.state.user.level === '3') {
            permissionF = ['store', 'stock', 'order', 'activity', 'gift']
            permissionS = ['storeStock', 'confirmOrder', 'applyActivity', 'joinActivity']
          }
          if (this.$store.state.user.level === '2') {
            permissionF = ['store']
            permissionS = ['storeAudit']
          }
          if (this.$store.state.user.adminRole === 'superAdmin' || (this.$store.state.user.adminRole === 'admin' && this.can('reviewGiftApplyModel'))) {
            permissionF = ['gift']
            permissionS = ['regionalGift']
          }
          return {
            permissionF: permissionF || [],
            permissionS: permissionS || [],
            user: this.$store.state.user.objectId,
            readUser: this.$store.state.user.objectId
            // offset: this.offset
          }
        },
        result ({ data: res }) {
          console.log(res)
          let beforeCount = this.messageCount
          this.messageCount = 0
          // 深拷贝
          let arr = res.platformNotice
          this.notification = arr
          this.notificationGroup = this.arrGroup(this.notification, item => item.type)
          console.log('this.notificationGroup', this.notificationGroup)
          for (let key in this.notificationGroup) {
            let s = this.notificationGroup[key]
            // 向上取整
            let totalPage = s.result.length % 3 === 0 ? s.result.length / 3 : parseInt(s.result.length / 3) + 1
            s.currentPage = s.currentPage > totalPage ? totalPage : s.currentPage
            // 判断是否为最后一页
            if (s.currentPage === totalPage) {
              s.renderNotification = s.result.slice((s.currentPage - 1) * 3, s.result.length)
            } else {
              s.renderNotification = s.result.slice((s.currentPage - 1) * 3, s.currentPage * 3)
            }
            this.messageCount += s.result.length
          }
          console.log('this.notificationGroup', this.notificationGroup)
          // 循环notificationGroup排序
          let arrSort = []
          for (let key in this.notificationGroup) {
            arrSort.push({
              key,
              length: this.notificationGroup[key].result.length
            })
          }
          arrSort.sort((a, b) => b.length - a.length)
          let obj = {}
          arrSort.forEach(item => {
            obj[item.key] = this.notificationGroup[item.key]
          })
          this.notificationGroup = obj

          this.showNotice(this.messageCount - beforeCount > 0 ? 'add' : 'sub')
        },
        fetchPolicy: 'no-cache' // 解决缓存问题
      })
    },
    // 标记为已读
    async markRead (order, index, key) {
      let res = await this.$tkParse.get(`/classes/platformNotice/${order.objectId}`)
      if (res.data.readUsers.indexOf(this.user.objectId) === -1) {
        res.data.readUsers.push(this.user.objectId)
        await this.$tkParse.put(`/classes/platformNotice/${order.objectId}`,
          { readUsers: res.data.readUsers }
        )
      }
    },
    // 切换分页
    change (key, pageSize, page) {
      switch (key) {
        case 'store':
          this.page0 = page
          break
        case 'stock':
          this.page1 = page
          break
        case 'order':
          this.page2 = page
          break
        case 'gift':
          this.page3 = page
          break
        case 'activity':
          this.page4 = page
          break
        default:
          break
      }
      this.notificationGroup[key].currentPage = page
      this.notificationGroup[key].renderNotification = this.notificationGroup[key].result.slice((page - 1) * 3, Math.min(page * 3, this.notificationGroup[key].result.length))
    },
    // 跳转到指定页面
    async toNewPage (order, index, key) {
      this.markRead(order, index, key)
      switch (key) {
        case 'store':
          switch (order.associationType) {
            case 'warehousing':
              let inboundOrder = await this.$tkParse.get(`/classes/inboundOrder/${order.resourceId}`)
              if (inboundOrder.data.type === 'purchase') {
                this.$router.push({ path: '/incomingOrders/orderDetail',
                  query: { id: order.resourceId } })
              } else {
                this.$router.push({ path: '/incomingOrders/consignOrderDetail',
                  query: { id: order.resourceId } })
              }
              break
            case 'outWarehouse':
              this.$router.push({ path: '/outboundOrder/outboundDetail',
                query: { id: order.resourceId } })
              break
            case 'transfer':
              this.$router.push({ path: '/transferSlip/transferSlipDetail',
                query: { id: order.resourceId } })
              break
            case 'inventory':
              this.$router.push({ path: '/takeStock/storehouseStockDetail',
                query: { id: order.resourceId } })
              break
            case 'storeAudit':
              if (order.className === 'store') {
                this.$router.push({ path: '/store' })
              } else {
                this.$router.push({ path: '/storeInfoUpdate' })
              }
              break
          }
          break
        case 'stock':
          switch (order.associationType) {
            case 'sales':
              this.$router.push({ path: '/order/sellOrder/sellOrderDetail',
                query: { id: order.resourceId } })
              break
            case 'self':
              this.$router.push({ path: '/order/selfOrder/selfOrderDetail',
                query: { id: order.resourceId } })
              break
            case 'identification':
              let idenOrder = await this.$tkParse.get(`/classes/authenticationOrder/${order.resourceId}`)
              if (idenOrder.data.type === 'aIIdentification') {
                this.$router.push({ path: '/order/orderDetail',
                  query: { id: order.resourceId } })
              } else {
                this.$router.push({ path: '/order/identifyOrderDetail',
                  query: { id: order.resourceId } })
              }
              break
            case 'mall':
              this.$router.push({ path: '/order/mallOrder/mallOrderDetail',
                query: { id: order.resourceId } })
              break
            case 'pos':
              this.$router.push({ path: '/order/posOrder/posOrderDetail',
                query: { id: order.resourceId } })
              break
            case 'storeStock':
              let { data: res } = await this.$tkParse.get(`/classes/${order.className}/${order.resourceId}`)
              this.$router.push({ path: '/store/storeDetail', query: { id: res.store, index: 1 } })
              break
          }
          break
        case 'order':
          this.$router.push({ path: '/order/detail', query: { id: order.resourceId } })
          break
        case 'gift':
          if (order.associationType === 'regionalGift') {
            this.$router.push({ path: '/commodity/giftApplyDetail',
              query: { id: order.resourceId } })
          }
          break
        case 'activity':
          switch (order.associationType) {
            case 'applyActivity':
              let { data: activityApplyRecord } = await this.$tkParse.get(`/classes/activityApplyRecord/${order.resourceId}`, {
                params: {
                  include: 'marketingCampaign'
                }
              })
              console.log(activityApplyRecord)
              let activityType = activityApplyRecord.marketingCampaign.activityType
              switch (activityType) {
                case '0': // 排名活动
                  this.$router.push({ path: '/activity/ranking/detail', query: { id: activityApplyRecord.marketingCampaign.objectId } })
                  break
                case '1': // 堆头活动
                  this.$router.push({ path: '/activity/stackhead/detail', query: { id: activityApplyRecord.marketingCampaign.objectId } })
                  break
                case '2': // 骑行活动
                  this.$router.push({ path: '/activity/riding/detail', query: { id: activityApplyRecord.marketingCampaign.objectId } })
                  break
                case '3': // 瓜分现金活动
                  this.$router.push({ path: '/model/activityJoinRecord', query: { id: activityApplyRecord.marketingCampaign.objectId } })
                  break
              }
              break
            case 'joinActivity':
              let { data: res } = await this.$tkParse.get(`/classes/activityJoinRecord/${order.resourceId}`, {
                params: {
                  include: 'marketingCampaign'
                }
              })
              let type = res.marketingCampaign.activityType
              switch (type) {
                case '0': // 排名活动
                  this.$router.push({ path: '/activity/ranking/detail', query: { id: res.marketingCampaign.objectId } })
                  break
                case '1': // 堆头活动
                  this.$router.push({ path: '/activity/stackhead/detail', query: { id: res.marketingCampaign.objectId } })
                  break
                case '2': // 骑行活动
                  this.$router.push({ path: '/activity/riding/detail', query: { id: res.marketingCampaign.objectId } })
                  break
                case '3': // 瓜分现金活动
                  this.$router.push({ path: '/model/activityJoinRecord' })
                  break
              }
              break
          }
          break
        default:
          break
      }
    },
    myDate (str) {
      let date = new Date(str)
      return [[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'), [date.getHours(), date.getMinutes()].join(':')].join(`     `).replace(/(?=\b\d\b)/g, '0')
    },
    fetchNotice () {
      if (!this.visible) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 500)
      } else {
        this.loading = false
      }
      this.visible = !this.visible
    },
    showNotice (type) {
      if (type === 'add') {
        this.$notification.open({
          message: '消息通知',
          description: '您有一个新的消息通知，请及时处理',
          icon: <a-icon type="bell" style="color: #FF9736" />,
          duration: 13,
          top: '80px'
        })
      }
      // else {
      //   let show = sessionStorage.getItem('show')
      //   if (!show) {
      //     sessionStorage.setItem('show', '1') // 显示
      //     this.$notification.open({
      //       message: '消息通知',
      //       description: '您有一个新的消息通知，请及时处理',
      //       icon: <a-icon type="bell" style="color: #FF9736" />,
      //       duration: 13,
      //       top: '80px'
      //     })
      //   }
      // }
    }
  }
}
</script>

<style lang="css">
  .header-notice-wrapper {
    top: 50px !important;
  }
</style>
<style lang="less" scoped>
.header-notice {
  display: inline-block;
  transition: all 0.3s;

  span {
    vertical-align: initial;
  }
}
</style>

<style lang="scss" scoped>
::v-deep .ant-popover-inner-content {
  padding: 12px 10px !important;
}
</style>
